function ServiceProviderServiceJobMarker({
  boxWidth = 30,
  boxHeight = 30,
  text,
  textColor = '#000000',
  boxColor = '#00c0ff',
  boxStrokeWidth = 2,
  boxStrokeColor = '#009ACD',
}) {
  const minFontSize = 18;
  const letterSpacing = '4';
  const fontFamily = 'Arial';
  const fontWeight = '500';
  const paddingX = 12;
  const paddingY = 2;

  const tempSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const tempText = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'text',
  );
  tempText.setAttribute('font-weight', fontWeight);
  tempText.setAttribute('font-size', minFontSize);
  tempText.setAttribute('font-family', fontFamily);
  tempText.setAttribute('letter-spacing', letterSpacing);
  tempText.textContent = text;
  tempSvg.appendChild(tempText);
  document.body.appendChild(tempSvg);
  const bbox = tempText.getBBox();
  document.body.removeChild(tempSvg);

  const contentWidth = bbox.width + paddingX * 2;
  const contentHeight = bbox.height + paddingY * 2;

  const finalBoxWidth = Math.max(boxWidth, contentWidth);
  const finalBoxHeight = Math.max(boxHeight, contentHeight);

  const viewBoxWidth = finalBoxWidth + boxStrokeWidth * 2;
  const viewBoxHeight = finalBoxHeight + boxStrokeWidth * 2;

  // Create SVG element
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', viewBoxWidth);
  svg.setAttribute('height', viewBoxHeight);
  svg.setAttribute('viewBox', `0 0 ${viewBoxWidth} ${viewBoxHeight}`);

  // Create rect
  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('x', boxStrokeWidth);
  rect.setAttribute('y', boxStrokeWidth);
  rect.setAttribute('width', finalBoxWidth);
  rect.setAttribute('height', finalBoxHeight);
  rect.setAttribute('fill', boxColor);
  rect.setAttribute('stroke', boxStrokeColor);
  rect.setAttribute('stroke-width', boxStrokeWidth);
  rect.setAttribute('rx', 4);
  rect.setAttribute('ry', 4);
  svg.appendChild(rect);

  // Create text
  const textElement = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'text',
  );
  textElement.setAttribute('x', '50%');
  textElement.setAttribute('y', '55%');
  textElement.setAttribute('transform', '');
  textElement.setAttribute('fill', textColor);
  textElement.setAttribute('transform', ''); // Remove scaling
  textElement.setAttribute('font-weight', fontWeight);
  textElement.setAttribute('font-size', minFontSize);
  textElement.setAttribute('text-anchor', 'middle');
  textElement.setAttribute('dominant-baseline', 'central');
  textElement.setAttribute('font-family', fontFamily);
  textElement.setAttribute('letter-spacing', letterSpacing);
  textElement.textContent = text;
  svg.appendChild(textElement);

  return svg;
}

export default ServiceProviderServiceJobMarker;
